import { AgentTool } from './AgentTool';
import './AdminTools.scss';

export function AdminTools() {
  return (
    <>
      <AgentTool />
    </>
  );
}

export default AdminTools;
